import { AppProviderContext } from '@websrc/App/AppContext'
import { useContext } from 'react'

export const useLocale = () => {
  const { locale } = useContext(AppProviderContext)

  return locale
}
